import { Row, Col, Form, Button } from "antd";
import { useContext, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import CustomFormItems from "../common/CustomFormItems";
import { IndexContext } from "../../context/IndexContext";

const layout = {
  labelCol: {
    span: 24,
    padding: 0,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function ActivityDataForm({
  currentlyEditEmissionID,
  getAllEmissionData,
  setIsModalOpen,
  existingActivityData,
}) {
  const [form] = Form.useForm();

  const [fetchWrapper] = useFetch();

  const { notificationApi } = useContext(IndexContext);

  const [buttonLoading, setButtonLoading] = useState(false);

  const [unitOptions, setUnitOptions] = useState([]);

  const form_properties = [
    {
      type: "select",
      name: "Unit",
      label: "Unit",
      options: unitOptions,
      required: true,
    },
    {
      type: "input-number",
      name: "Consumption",
      label: "Consumption",
      required: true,
    },
  ];

  function getActivityDataUnit() {
    fetchWrapper({
      endpoint_url: "emission_data_entry/getActivityDataUnit",
      method: "GET",
      set_content_type_header: false,
      params: { activity_data_ID: currentlyEditEmissionID },
      onSuccess: (response) => {
        setUnitOptions(response.data);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
    });
  }

  /** API to save activity data */
  function saveActivityData(form_data) {
    // set to button loading
    setButtonLoading(true);

    fetchWrapper({
      endpoint_url: "emission_data_entry/saveActivityData",
      method: "POST",
      body: {
        form_data: form_data,
        activity_data_ID: currentlyEditEmissionID,
      },
      onSuccess: (response) => {
        setButtonLoading(false);
        setIsModalOpen(false);
        getAllEmissionData();
        notificationApi.success({
          message: response.message,
        });
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
    });
  }

  useEffect(() => {
    if (existingActivityData) {
      form.setFieldValue("Consumption", existingActivityData.split(" ")[0]);
      form.setFieldValue("Unit", existingActivityData.split(" ")[1]);
    }
  }, []);

  useEffect(() => {
    if (getActivityDataUnit) {
      getActivityDataUnit();
    }
  }, [currentlyEditEmissionID]);

  return (
    <Row>
      <Col span={12} offset={6}>
        <Form {...layout} form={form} onFinish={saveActivityData}>
          <CustomFormItems form_properties={form_properties} />
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={buttonLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
}
